import VisibleComponent from "../VisibleComponent";
import Button from "../Button";

const template = `
    <div class="mtg-countdown-button"></div>
`

class CountdownButton extends VisibleComponent {
    constructor(options) {
        super(options);
        this.template = template
        this.displaySecond = null
        this.init(options)
    }

    init(options) {
        super.init(options);

        this.btnCountdown = new Button({
            type: 'countdown',
            onClick: e => {
                options && typeof options.onClick === 'function' && options.onClick(e)
            }
        });
        this.btnCountdown.appendTo(this.element)

        switch (options && options.position) {
            case "top right":
                this.element.classList.add("mtg-pos-top-right")
                break;
            default:
                // top left
                this.element.classList.add("mtg-pos-top-left")
        }
    }

    set countdown(sec) {
        if (isNaN(sec)) {
            return
        }
        this.displaySecond = sec

        let strCountdown = '' + sec
        if (strCountdown.length === 1) {
            strCountdown = '0' + strCountdown
        }
        this.btnCountdown.setText(strCountdown)
    }

    get countdown() {
        return this.displaySecond
    }
}

export default CountdownButton